import router from "@/core/common/router";
import { queryPost } from "@/core/service/api";
import { checkLoginIn } from "../service/api";

const standardtable = {
  namespaced: true,
  name: "entry",
  state: {
    code: -1,
    loading: false
  },
  mutations: {
    changeState(state, { payload }) {
      Object.assign(state, payload);
    }
  },
  actions: {
    async backgroundImage({ commit }, { payload }) {
      console.log(`payload`, payload)
      const response = await queryPost(payload, "/isg-projectapplication/gift/exchange/backgroundImage");
      const {code, result, msg} = response;
      if(code === '0'){
        return result;
      }else{
        this.$toast.fail(msg)
      }
      
    },
   
  }
};

export default standardtable;
